<!--
 * @Author: v_smwang
 * @Date: 2020-07-27 19:32:25
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-06-07 15:00:23
 * @FilePath: \src\views\personnel-portrait\personnel-portrait-details\overview.vue
 * @Description: 描述
 * @Module: 模块路径
-->
<template>
  <div class="personnel-portrait-details-content">
    <div class="main-content">
      <div class="query-form">
        <el-form :model="form" inline ref="form" :rules="rules">
          <el-form-item size="mini" label="开始日期" prop="start_time">
            <el-date-picker
              type="date"
              placeholder="选择日期"
              v-model="form.start_time"
              value-format="timestamp"
              class="comm-style"
            ></el-date-picker>
          </el-form-item>
          <el-form-item size="mini" label="结束日期" prop="end_time">
            <el-date-picker
              type="date"
              placeholder="选择日期"
              class="comm-style"
              value-format="timestamp"
              v-model="form.end_time"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="产线" size="mini" prop="production_line">
            <el-select
              v-model="form.production_line"
              filterable
              class="comm-style"
              @change="onProLineChange"
            >
              <template v-for="item in productionLine">
                <el-option :label="item.label" :value="item.id" :key="item.id" />
              </template>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="资料类型" size="mini" prop="data_types">
            <el-select
              v-model="form.data_types"
              clearable
              class="comm-style"
            >
                <el-option label="常规" :value="0" :key="0" />
            </el-select>
          </el-form-item>
          <el-form-item label="生产版本" size="mini" prop="production_versions">
            <el-select
              v-model="form.production_versions"
              clearable
              class="comm-style"
            >
                <el-option label="新增" :value="0" :key="0" />
            </el-select>
          </el-form-item> -->
          <el-form-item v-if="taskTypeChange" label="任务类型" size="mini" prop="production_line">
            <el-select
              v-model="form.task_type"
              filterable
              class="comm-style"
              @change="onTasktypeChange"
            >
              <template v-for="item in taskTypeList">
                <el-option :label="item.label" :value="item.value" :key="item.value" />
              </template>
            </el-select>
          </el-form-item>
          <el-form-item v-if="form.task_type && form.production_line != 'merge_0001'" label="任务标签" size="mini" prop="task_label">
            <el-select
              v-model="form.task_label"
              filterable
              class="comm-style"
            >
              <template v-for="item in taskLabelList">
                <el-option :label="item.label" :value="item.value" :key="item.value" />
              </template>
            </el-select>
          </el-form-item>
          <el-form-item label="统计周期" size="mini" prop="time_type">
            <el-select v-model="form.time_type" prop="time_type" class="comm-style">
              <el-option label="天" value="天" />
              <el-option label="自然周" value="自然周" />
              <el-option label="汇报周" value="汇报周" />
              <el-option label="自然月" value="自然月" />
              <el-option label="结算月" value="结算月" />
            </el-select>
          </el-form-item>
          <el-form-item label="人员" size="mini" prop="operator">
            <el-select v-model="form.operator" filterable class="comm-style">
              <template v-for="i in ops">
                <el-option :label="i.label" :value="i.id" :key="i.id" />
              </template>
            </el-select>
          </el-form-item>
          <el-form-item>
            <div class="wrap-btn">
              <el-button type="primary" class="btn-style" @click="querybtn">查询</el-button>
              <el-button @click="reset('form')" class="btn-style">重置</el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div>
        <div class="tabs">
          <el-tabs v-model="operatorType" @tab-click="clickOp">
            <el-tab-pane label="制作员" name="zhizuo"></el-tab-pane>
            <el-tab-pane label="内检员" name="neijian" :disabled="true"></el-tab-pane>
          </el-tabs>
        </div>
      </div>
      <div class="content-result">
        <el-card class="el-card-style">
          <div class="first-content">
            <div class="first-content-left">
              <div
                class="first-content-left-title"
              >作业员名称：{{`${info.operator_cn||''}(${info.operator})`}}</div>
              <div style="margin-top: 29px">
                <ve-radar
                  v-loading="raderLoading"
                  :after-config="afterConfig"
                  width="400px"
                  :data="chartRadarData"
                  :extend="radarExtend"
                  :events="chartEvents"
                ></ve-radar>
              </div>
            </div>
            <div class="content-right">
              <div
                class="first-content-left-title"
                style="margin-bottom: 25px;"
              >所属供应商：{{info.outsourcer}}</div>
              <div class="second-content">
                <div class="second-content-top">
                  <span>
                    <div>产线综合排名</div>
                    <i :style="{color:colorI}">
                      {{info&&info.production_line_rank.split('/')[0]}}
                      <b>/{{info&&info.production_line_rank.split('/')[1]}}</b>
                    </i>
                  </span>
                  <span>
                    <div>供应商综合排名</div>
                    <i :style="{color:colorI}">
                      {{info&&info.outsourcer_rank.split('/')[0]}}
                      <b>/{{info&&info.outsourcer_rank.split('/')[1]}}</b>
                    </i>
                  </span>
                  <span>
                    <div>综合评价</div>
                    <i :style="{color:colorI}">{{info&&info.evaluation}}</i>
                  </span>
                  <span>
                    <div>培养建议</div>
                    <i :style="{color:colorI}">{{info&&info.advice}}</i>
                  </span>
                </div>
                <div class="second-content-bottom">
                  <el-table :data="info.rank_detail" ref="tableTop" v-loading="loadingInfoDetail">
                    <el-table-column prop="label" label="指标名称" />
                    <el-table-column prop="value" label="指标值" :formatter="formatterValue"></el-table-column>
                    <el-table-column prop="standard" label="标准值" :formatter="formatterStandard"></el-table-column>
                    <el-table-column prop="outsourcer_rank" width="100" label="供应商排名" />
                    <el-table-column prop="production_line_rank" width="100" label="产线内排名" />
                    <el-table-column prop="total_rank" label="总排名" />
                  </el-table>
                </div>
              </div>
            </div>
          </div>
        </el-card>
        <div style="display:flex">
        <el-card style="width:50%" class="el-card-style">
          <div class="dimension-content-top">
            <div class="comm-title-line-style">综合评分时间趋势</div>
            <div>
                  <el-select
                    @change="onOverallRatingChange"
                    size="mini"
                    v-model="zbDetail"
                    class="dimension-content-top-select"
                  >
                    <template v-for="item in overallRatingSelectDetail">
                      <el-option :label="item.label" :value="item.value" :key="item.label" />
                    </template>
                  </el-select>
              </div>
            </div>
          <div style="width: 100%">
            <ve-line
              width="100%"
              :data="overallRating"
              :extend="lineExtendRating"
              :data-zoom="dataZoom"
              @ready-once="readyOnce"
              v-loading="overallRatingLoading"
            ></ve-line>
          </div>
        </el-card>
        <el-card style="margin-bottom: 10px;width:50%">
          <div class="dimension-content">
            <div class="dimension-content-top">
              <div class="comm-title-line-style">评价维度时间趋势</div>
              <div>
                <el-select
                  @change="onDimensionChange"
                  size="mini"
                  v-model="zb"
                  class="dimension-content-top-select"
                >
                  <template v-for="item in dimensionSelectDetail">
                    <el-option :label="item.label" :value="item.value" :key="item.label" />
                  </template>
                </el-select>
              </div>
            </div>
            <div>
              <ve-line
                :data="dimensionChartData"
                @ready-once="readyOnce"
                :data-zoom="dataZoom"
                v-loading="dimensionLoading"
                :extend="dimensionExtend"
              ></ve-line>
            </div>
          </div>
        </el-card>
        </div>
        <el-card style="margin-bottom: 10px;">
          <div class="targetDetail">
            <div class="comm-title-line-style">指标详情</div>
            <span class="export-span" @click="exportDetail">导出</span>
          </div>
          <div>
            <el-table
              :data="detailData"
              border
              v-loading="loadingDetail"
              class="detail-table-style"
              style="width: 100%"
            >
              <template v-for="item in detailConfig">
                <el-table-column
                  :prop="item.name"
                  :label="item.label"
                  :key="item.name"
                  :width="item.width||''"
                  :fixed="item.fixed||false"
                >
                  <template slot-scope="scope">
                    <span>{{computedData(scope,item)}}</span>
                  </template>
                </el-table-column>
              </template>
            </el-table>
            <el-pagination
              style="text-align: right;margin-top:10px;"
              :page-size="10"
              background
              layout="total,sizes,prev, pager, next,jumper"
              @current-change="onPaginationChange"
              @size-change="onSizeChange"
              :page-sizes="[10, 20, 30, 40]"
              :total="totalCount"
            ></el-pagination>
          </div>
        </el-card>
            <!-- 缺陷详情 -->
        <el-card>
          <div class="part-content">
            <div class="chart-title">
              {{ defectDetails.title }}
              <a-tooltip placement="top">
                <template slot="title">
                  <!-- <span>{{ defectDetails.Production }}</span> -->
                        <span>1、左侧柱状图</span><br/>
                        <span>折线：缺陷数量占比 = 本人该类缺陷数量 / 本人缺陷总量</span> <br/>
                        <span>2、右侧表格</span><br/>
                        <span>公司内缺陷占比：缺陷占比 = 本人该类缺陷数量 / 本人所在公司该类缺陷总量</span>
                </template>
                <a-icon type="question-circle" />
              </a-tooltip>
            </div>
          <div style="padding:20px 0">
            <el-select defaultValue=''
                      class='select-a'
                      v-model="defectForm.resume_type"
                      @change="productionLineChange(1)"
                      style="min-width: 150px">
              <el-option v-for="item in resumeTypeOpthons" :value="item.val" :label="item.key"
                              :key="item.val">
              </el-option>
            </el-select>
            <el-select defaultValue=''
                      class='select-a'
                      v-model="defectForm.error_secondary"
                      @change="productionLineChange(2)"
                      style="min-width: 150px">
              <el-option v-for="item in error_secondary" :value="item.val" :label="item.key"
                              :key="item.val">
              </el-option>
            </el-select>
          </div>
            <div style="display:flex">
              <el-card style="width:50%" class="el-card-style">
                  <ve-histogram
                    width="100%"
                    v-loading="defectDetailsLoading"
                    :data="defectDetails"
                    @ready-once="readyOnce"
                    :settings="{...outputSetting,...defectDetails.settings}"
                    :extend="lineExtend"
                  >
                  </ve-histogram>
              </el-card>
              <el-card style="margin-bottom: 10px;width:50%">
                <div  style="border:none;">
                  <div style="" class="trend">公司内缺陷占比</div>
                  <div class="tableInfo">
                    <a-spin :spinning="itemdefectDetailsLineLoading">
                      <div class="tableTou" style="">
                        <p class="tableTouInfo" :style="`width:${itemdefectDetailsLine.width}%;min-width:140px`" :key="index" v-for="(item,index) in itemdefectDetailsLine.columns">{{item == 'statis_time'? '日期': item}}</p>
                      </div>
                        <div class="tableTd"  v-for="(item,index) in itemdefectDetailsLine.rows" :key="index">
                                <!-- <p class="tableDd" :style="`width:${itemdefectDetailsLine.width}%;min-width:120px`" >{{item.statis_time}}</p>
                                <p class="tableDd" :style="`width:${itemdefectDetailsLine.width}%;min-width:120px`" v-if="info !== 'statis_time'" v-for="(info,infoNum) in Object.keys(item)" :key="infoNum">{{info === 'statis_time' ? item[info] : `${(item[info]*100).toFixed(2)}%`}}</p> -->
                                <p class="tableDd" :style="`width:${itemdefectDetailsLine.width}%;min-width:140px`"  v-for="(info,infoNum) in itemdefectDetailsLine.columns" :key="infoNum">{{info === 'statis_time' ? item[info] : `${(item[info]*100).toFixed(2)}%`}}</p>
                          <!-- <p class="tableDd" :style="`width:${itemdefectDetailsLine.width}%;min-width:120px`" v-for="(info,infoNum) in Object.keys(item)" :key="infoNum">{{info === 'statis_time' ? item[info] : `${(item[info]*100).toFixed(2)}%`}}</p> -->
                        </div>
                      <!-- <ve-line
                        style="width:100%;"
                        height="595px"
                        :data="itemdefectDetailsLine"
                        :loading="defectDetailsLineLoading"
                        :colors="$color"
                        :ref="itemdefectDetailsLine.name ? itemdefectDetailsLine.name + 'ref' : ''"
                        :extend="extend1"
                        :settings="{ ...outputSetting, ...itemdefectDetailsLine.settings }"
                      >
                      </ve-line> -->
                    </a-spin>
                  </div>
                </div>
                <!-- <div class="dimension-content">
                  <ve-line
                    width="100%"
                    v-loading="itemdefectDetailsLineLoading"
                    :data="itemdefectDetailsLine"
                    @ready-once="readyOnce"
                    :settings="itemdefectDetailsLine.settings "
                    :extend="seriesLabel1"
                  >
                  </ve-line>
                </div> -->
              </el-card>
            </div>
            <!-- <div style="display:flex;">
                <ve-histogram
                  width="100%"
                  v-loading="defectDetailsLoading"
                  :data="defectDetails"
                  :ref="defectDetails.name ? defectDetails.name + 'ref' : ''"
                  :settings="{...outputSetting,...defectDetails.settings}"
                  :extend="lineExtend"
                >
                </ve-histogram>
                <ve-line
                  width="100%"
                  v-loading="itemdefectDetailsLineLoading"
                  :data="itemdefectDetailsLine"
                  :ref="itemdefectDetailsLine.name ? itemdefectDetailsLine.name + 'ref' : ''"
                  :settings="itemdefectDetailsLine.settings "
                  :extend="seriesLabel1"
                >
                </ve-line>
            </div> -->
          </div>
          </el-card>
          <el-card>
          <div style="z-index: 99999; position: relative;margin-bottom:100px" class="relative part-box gap-top">
            <div class="part-title">
              <div style="float:right" class="part-right">
                <span class="export-span"
                type="primary"
                  @click="exportFile()"
                >
                  导出
                </span>
              </div>
            </div>
            <div class="part-content">
              <el-table :data="tableData" style="width: 100%">
                <el-table-column
                  v-for="item in defectDetialsColumns"
                  :key="item.dataIndex"
                  :label="item.title"
                  :align="item.align"
                  :prop="item.dataIndex"
                  :width="item.width">
                </el-table-column>
              </el-table>
              <el-pagination
              style="float:right;margin-top:10px"
                @current-change="currentChange"
                background
                :page-count="pagination.pageNo"
                :page-size="pagination.pageSize"
                layout="prev, pager, next"
                :total="pagination.totalCount">
              </el-pagination>
            </div>
          </div>
        </el-card>
      </div>
    </div>
  </div>
</template>

<script>
import {
  detailConfigs,
  radarExtend,
  info,
  lineExtendRating,
  dataZoom,
  dimensionSelect,
  overallRatingSelect,
  dimensionExtend,
  rules,
} from './config';
import {
  getProductionLine,
  getOperator,
  getScore,
  getInfo,
  getComprehensive,
  getDimension,
  getDetailZb,
  getzbExport,
  getTaskType,
  getTaskLabel,
} from '@/api/personalPorDetail';
import api from '@/api/pv_report';
import moment from 'moment';
import { downloadBlobFile } from '@/utils/download';

export default {
  data() {
    this.seriesLabel1 = {
      series: {
        type: 'line',
        label: {
          show: true,
          position: 'top',
          // formatter:'{@[1]}%'
          formatter: params => `${params.data[1] * 100}%`,
        },
      },
    };
    this.lineExtend = {
      series: {
        barMaxWidth: '70',
        label: {
          show: true,
          position: 'inside ',
          formatter: (params) => {
            if (params.seriesType === 'line') {
              return `${params.data}%`;
            }
          },
        },
      },
    };
    this.outputSetting = {
      labelMap: {
        count: '数量',
        exception_type_rate: '占比',
      },
    };

    return {
      taskTypeChange: false,
      defectDetailsLoading: false,
      itemdefectDetailsLineLoading: false,
      info,
      rules,
      radarExtend,
      pageSize: 10,
      totalCount: 0,
      dimensionExtend: dimensionExtend[0],
      detailConfig: detailConfigs.zhizuo,
      dimensionSelectDetail: dimensionSelect.zhizuo,
      overallRatingSelectDetail: overallRatingSelect.zhizuo,
      detailData: [],
      operatorType: 'zhizuo',
      zb: '1',
      zbDetail: '0',
      loadingInfoDetail: false, // 加载用户排名loading
      loadingDetail: false, // 加载指标详情loading
      overallRatingLoading: false, // 综合评分时间趋势loading
      raderLoading: false, // 雷达图加载loading
      dimensionLoading: false, // 综合评分时间趋势loading
      form: {
        start_time: moment().subtract(7, 'days')
          .startOf('day')
          .valueOf(),
        end_time: moment().subtract(1, 'days')
          .startOf('day')
          .valueOf(),
        production_line: '',
        time_type: '天',
        operator: '',
        task_type: '',
        task_label: '',
        outsourcer: '',
      },
      chartEvents: {},
      dimension: '',
      productionLine: [],
      taskTypeList: [], // 任务类型列表
      taskLabelList: [], // 任务标签列表
      overallRating: {
        columns: ['日期', '综合得分'],
        rows: [],
      },
      chartRadarData: {
        columns: ['分类', '质量', '效率', '产量', '有效时长'],
        rows: [],
      },
      dimensionChartData: {
        columns: ['日期', '一次验收缺陷率', '目标缺陷率'],
        rows: [],
      },
      ops: [],
      lineExtendRating,
      dataZoom,
      // 以下  缺陷详情
      defectDetails: {
        span: 12,
        type: 'dw_mid',
        title: '缺陷详情',
        Production: '',
        columns: ['exception_text', 'count', 'exception_type_rate'],
        rows: [],
        settings: {
          axisSite: { right: ['exception_type_rate'] },
          showLine: ['exception_type_rate'],
          yAxisType: ['KMB', 'KMB'],
          yAxisName: ['数量', '占比'],
        },
      },
      itemdefectDetailsLine: {
        span: 12,
        type: 'dw_mid',
        title: '缺陷详情',
        width: '',
        Production: '',
        columns: [],
        rows: [],
        settings: {
          // labelMap:['statis_time','bpl','sdbp','dm','xsx','kcd'],
          yAxisType: ['percent'],
          yAxisName: ['占比'],
        },
      },
      tableData: [], // 缺陷详情 表格数据
      defectForm: { // 缺陷详情筛选项
        resume_type: 'external',
        error_secondary: 'scene',
      },
      resumeTypeOpthons: [// 缺陷项详情 一级筛选
        {
          key: '内检缺陷',
          val: 'internal',
        },
        {
          key: '验收缺陷',
          val: 'external',
        },
      ],
      error_secondary: [// 缺陷项详情 二级筛选
        {
          key: '缺陷类型',
          val: 'type',
        },
        {
          key: '缺陷项',
          val: 'item',
        },
        {
          key: '缺陷场景',
          val: 'scene',
        },
      ],
      defectDetialsColumns: [ // 缺陷详情表头
        {
          title: '日期',
          dataIndex: 'log_time',
          align: 'center',
          width: 120,
        },
        {
          title: '作业编号',
          dataIndex: 'work_number',
          align: 'center',
          width: 120,
        },
        {
          title: '任务编号',
          dataIndex: 'task_number',
          align: 'center',
          width: 120,
        },
        {
          title: '产线',
          dataIndex: 'production_line_name',
          align: 'center',
          width: 120,
        },
        {
          title: '作业人员',
          dataIndex: 'work_operator',
          align: 'center',
          width: 120,
        },
        {
          title: '内检人员',
          dataIndex: 'check_operator',
          align: 'center',
          width: 120,
        },
        {
          title: '缺陷项',
          dataIndex: 'exception_item',
          align: 'center',
          width: 120,
        },
        {
          title: '缺陷类别',
          dataIndex: 'exception_type',
          align: 'center',
          width: 120,
        },
        {
          title: '缺陷场景',
          dataIndex: 'exception_scene',
          align: 'center',
          width: 120,
        },
        {
          title: '错误等级',
          dataIndex: 'exception_level',
          align: 'center',
          width: 120,
        },
        {
          title: '错误描述',
          dataIndex: 'memo',
          align: 'center',
          width: 120,
        },
      ],
      fromData: {},
      pagination: {
        pageNo: 1,
        pageSize: 10,
        totalCount: 100,
      },
      // 以上 缺项详情开发
    };
  },
  created() {
    // this.isFromOverView()
    if (window.location.href.includes('tianshu')) {
      this.PV_report();
    }
    // let message = 1
    // window.parent.postMessage(message, '*')
  },
  mounted() {
    this.initData();
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.isFromOverView();
    });
  },
  computed: {
    colorI() {
      let color = '';
      switch (this.info.evaluation) {
        case '高质高效':
          color = 'green';
          break;
        case '高质低效':
          color = 'orange';
          break;

        case '低质高效':
          color = 'orange';
          break;

        case '低质低效':
          color = 'red';
          break;

        default:
          color = '#5584ED';
          break;
      }
      return color;
    },
  },
  watch: {
    'form.start_time': {
      handler(newVal, oldVal) {
        this.setOper();
        this.setProductionLine();
        // this.setTaskTypeList();
        // this.setTaskLabelList();
      },
      // immediate: true,
      deep: true,
    },
    'form.end_time': {
      handler(newVal, oldVal) {
        this.setOper();
        this.setProductionLine();
        // this.setTaskTypeList();
        // this.setTaskLabelList();
      },
      // immediate: true,
      deep: true,
    },
  },
  methods: {
    formatterValue(row, column) {
      if (row.value === null) {
        return '-';
      }
      if (row.label === '验收一次缺陷率' || row.label === '内检人员缺陷率') {
        return Number.isNaN(Number(row.value)) ? row.value : (`${Number(row.value * 100).toFixed(2)}%`);
      }
      return Number.isNaN(Number(row.value)) ? row.value : Number(row.value).toFixed(2);
    },
    formatterStandard(row, column) {
      if (row.standard === null) {
        return '-';
      }
      if (row.label === '验收一次缺陷率' || row.label === '内检人员缺陷率') {
        return Number.isNaN(Number(row.standard)) ? row.standard : (`${Number(row.standard * 100).toFixed(2)}%`);
      }
      return Number.isNaN(Number(row.standard)) ? row.standard : Number(row.standard).toFixed(2);
    },
    computedData(scope, item) {
      if (scope.row[item.name] === null) {
        return '-';
      }
      if (scope.column.property === 'zl') {
        return item.slot
          ? `${(Number(scope.row[item.name]) * 100).toFixed(2)}%`
          : scope.row[item.name];
      }
      if (scope.column.property === 'cl') {
        return item.slot
          ? (Number(scope.row[item.name])).toFixed(2)
          : scope.row[item.name];
      }
      if (item.slot) {
        return Number.isNaN(Number(scope.row[item.name])) ? scope.row[item.name] : Number(scope.row[item.name]).toFixed(2);
      }
      return scope.row[item.name];
    },
    isFromOverView() {
      // 是否从概览页跳转过来 是就查询
      this.taskTypeChange = false;
      if (JSON.stringify(this.$route.query) !== '{}') {
        this.form = {
          ...this.form,
          ...this.$route.query,
          time_type: '天', // 默认统计周期为天
        };
        this.setOper();
        this.setProductionLine();
        this.query();
      }
    },
    querybtn() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.query();
        } else {
          this.$notify.error({
            title: '错误',
            message: '请选择必填项',
          });
        }
      });
    },
    query() {
      this.setRaderData();
      this.setUserInfo();
      this.setComprehensive();
      this.setDimension();
      this.setDetailZb();
      // 缺陷详情
      this.getDefectDetailsTable();
      this.getDefectData();
    },
    onProLineChange() {
      this.form.operator = '';
      this.form.task_type = '';
      this.form.task_label = '';
      this.setTaskTypeList();
      this.setOper();
    },
    onTasktypeChange() {
      this.form.operator = '';
      this.form.task_label = '';
      this.setTaskLabelList();
      this.setOper();
    },
    async initData() {
      // await this.setProductionLine()
    },
    setProductionLine() {
      // 设置产线选项数据
      // eslint-disable-next-line camelcase
      const { start_time, end_time, platform } = this.form;
      return getProductionLine({
        start_time,
        end_time,
        operator_type: this.operatorType,
        platform,

      }).then((res) => {
        this.productionLine = res;
        if (this.form.platform === 2) {
          this.setTaskTypeList();
        }
        return true;
      });
    },
    // 获取任务类型
    async setTaskTypeList() {
      const { start_time, end_time, platform, production_line, outsourcer } = this.form;
      const params = {
        operator_type: 'zhizuo',
        start_time,
        end_time,
        production_line,
        platform,
        outsourcer,
      };
      const res = await getTaskType(params);
      if (res && res.length > 0) {
        this.taskTypeList = res.map(item => ({ value: item.id, label: item.label }));
        this.taskTypeChange = true;
        if (this.form.task_type === undefined) {
          this.form.task_type = res[0].id;
        }
        this.setTaskLabelList();
      } else {
        this.taskTypeList = [];
      }
    },
    // 获取任务标签
    async setTaskLabelList() {
      const { start_time, end_time, platform, production_line, outsourcer, task_type, task_label } = this.form;
      const params = {
        operator_type: 'zhizuo',
        start_time,
        end_time,
        production_line,
        platform,
        outsourcer,
        task_type,
        task_label,
      };
      const res = await getTaskLabel(params);
      if (res && res.length > 0) {
        this.taskLabelList = res.map(item => ({ value: item.id, label: item.label }));
        if (this.form.task_label === undefined) {
          this.form.task_label = res[0].id;
        }
      } else {
        this.taskLabelList = [];
      }
    },
    setOper() {
      // eslint-disable-next-line camelcase
      const { start_time, end_time, production_line, platform, task_type, task_label } = this.form;
      getOperator({
        start_time,
        end_time,
        operator_type: this.operatorType,
        production_line,
        platform,
        task_type,
        task_label,
      }).then((res) => {
        this.ops = res;
      });
    },
    setRaderData() {
      // eslint-disable-next-line camelcase
      const { start_time, end_time, production_line, operator, platform, task_type, task_label } = this.form;
      this.raderLoading = true;
      getScore({
        operator_type: this.operatorType,
        start_time,
        end_time,
        production_line,
        operator,
        platform,
        task_type,
        task_label,
      }).then((res) => {
        if (res && Object.keys(res).length > 0) {
          delete res.operator;
          delete res.production_line;
          const rows = [];
          let totalScore = 0;
          for (const item of Object.keys(res)) {
            if (/_standard/.test(item)) {
              rows[1] = {
                ...rows[1],
                [item]: res[item].toFixed(2),
              };
            } else if (/_weight/.test(item)) {
              rows[2] = {
                ...rows[2],
                [item]: res[item],
              };
            } else {
              const tmp = res[item].toFixed(2);
              totalScore += +tmp;
              rows[0] = {
                ...rows[0],
                [item]: tmp,
              };
            }
          }
          rows[0] && (rows[0].fl = '人员实际分数值');
          rows[1] && (rows[1].fl = '产线标准分');
          this.raderLoading = false;
          this.chartRadarData.rows = [rows[0], rows[1]].map(item => ({
            分类: item.fl,
            质量: item.zl || item.zl_standard,
            效率: item.xl || item.xl_standard,
            产量: item.cl || item.cl_standard,
            有效时长: item.hs || item.hs_standard,
          }));
          this.radarExtend.radar.indicator = radarExtend.radar.indicator.map((item) => {
            const tmp = item.name.split('\n')[0];
            return {
              name: `${tmp}\n(${rows[2][item.id]})`,
              id: item.id,
              max: rows[2][item.id],
            };
          });
          this.setRadderTitle(totalScore);
        }
        this.raderLoading = false;
      });
    },
    setUserInfo() {
      // eslint-disable-next-line camelcase
      const { start_time, end_time, production_line, operator, platform, task_type, task_label } = this.form;
      this.loadingInfoDetail = true;
      getInfo({
        operator_type: this.operatorType,
        start_time,
        end_time,
        production_line,
        operator,
        platform,
        task_type,
        task_label,
      })
        .then((res) => {
          this.loadingInfoDetail = false;
          if (Object.keys(res).length > 0) {
            this.info = res;
          } else {
            this.info = info;
          }
        })
        .catch(() => {
          this.loadingInfoDetail = false;
        });
    },
    // 综合评分时间趋势
    setComprehensive() {
      this.overallRatingLoading = true;
      getComprehensive({ ...this.form, operator_type: this.operatorType, zb: this.zbDetail, statistics_type: 'score' }).then((res) => {
        switch (this.zbDetail) {
          case '0':
            this.overallRating.columns = ['日期', '整体得分'];
            this.overallRating.rows = res.map(item => ({
              日期: item.time,
              整体得分: item.score,
            }));
            break;
          case '1':
            this.overallRating.columns = ['日期', '一次验收缺陷率'];
            this.overallRating.rows = res.map(item => ({
              日期: item.time,
              一次验收缺陷率: item.score,
            }));
            break;
          case '2':
            this.overallRating.columns = ['日期', '制作效率'];
            this.overallRating.rows = res.map(item => ({
              日期: item.time,
              制作效率: item.score,
            }));
            break;
          case '3':
            this.overallRating.columns = ['日期', '制作产量'];
            this.overallRating.rows = res.map(item => ({
              日期: item.time,
              制作产量: item.score,
            }));
            break;
          case '4':
            this.overallRating.columns = ['日期', '制作有效时长'];
            this.overallRating.rows = res.map(item => ({
              日期: item.time,
              制作有效时长: item.score.toFixed(2),
            }));
            break;
        }
        // this.overallRating.rows = res.map((item) => ({
        //   日期: item.time,
        //   综合得分: item.score
        // }))
        this.overallRatingLoading = false;
      });
    },
    setDimension() {
      // 设置评价维度时间趋势
      this.dimensionLoading = true;
      getDimension({
        ...this.form,
        operator_type: this.operatorType,
        zb: this.zb,
        statistics_type: 'value',
      }).then((res) => {
        switch (this.zb) {
          case '1':
            this.dimensionChartData.columns = ['日期', '一次验收缺陷率', '目标缺陷率'];
            this.dimensionChartData.rows = res.map(item => ({
              日期: item.time,
              一次验收缺陷率: item.score ? (item.score * 100).toFixed(2) : 0,
              目标缺陷率: item.standard ? (item.standard * 100).toFixed(2) : 0,
            }));
            break;
          case '2':
            this.dimensionChartData.columns = ['日期', '制作效率', '目标效率'];
            this.dimensionChartData.rows = res.map(item => ({
              日期: item.time,
              制作效率: item.score ? item.score.toFixed(2) : 0,
              目标效率: item.standard ? item.standard : 0,
            }));
            break;
          case '3':
            this.dimensionChartData.columns = ['日期', '制作产量', '标准产量'];
            this.dimensionChartData.rows = res.map(item => ({
              日期: item.time,
              制作产量: item.score ? item.score : 0,
              标准产量: item.standard ? item.standard : 0,
            }));
            break;
          case '4':
            this.dimensionChartData.columns = [
              '日期',
              '制作有效时长',
              '标准有效时长',
            ];
            this.dimensionChartData.rows = res.map(item => ({
              日期: item.time,
              制作有效时长: item.score ? item.score.toFixed(2) : 0,
              标准有效时长: item.standard ? item.standard : 0,
            }));
            break;
        }
        this.dimensionLoading = false;
      });
    },
    onDimensionChange(e) {
      this.dimensionExtend = dimensionExtend[e - 1];
      this.setDimension();
    },
    onOverallRatingChange(e) {
      this.dimensionExtend = dimensionExtend[e - 1];
      this.setComprehensive();
    },
    setDetailZb(params) {
      this.loadingDetail = true;
      getDetailZb({
        ...this.form,
        operator_type: this.operatorType,
        pageNo: 1,
        pageSize: this.pageSize,
        ...params,
      }).then((res) => {
        this.totalCount = res.totalCount;
        this.detailData = res.data;
        this.loadingDetail = false;
      });
    },
    reset(form) {
      this.$refs[form].resetFields();
    },
    onPaginationChange(current) {
      this.setDetailZb({ pageNo: current });
    },
    onSizeChange(size) {
      this.pageSize = size;
      this.setDetailZb({ pageSize: size });
    },
    clickOp(type) {
      this.detailConfig = detailConfigs[type.name];
      this.dimensionSelectDetail = dimensionSelect[type.name];
      this.overallRatingSelectDetail = overallRatingSelect[type.name];
      this.querybtn();
    },
    setRadderTitle(score) {
      // 设置综合得分
      radarExtend.title.text = `综合得分：${score}`;
      this.radarExtend = radarExtend;
    },
    afterConfig(config) {
      // config.radar.indicator = config.radar.indicator.map(item=>({
      //   ...item,
      //   max:
      // }))
      if (config.series[0].data[1]) {
        config.series[0].data[1].symbolSize = 1;
        config.series[0].data[1].label = {
          show: true,
          color: '#FA7962',
        };
        config.series[0].data[1].areaStyle = {
          color: '#FA7962',
          opacity: 0.1,
        };
        config.series[0].data[1].lineStyle = {
          color: '#DDACA8',
          width: 2,
        };
        config.series[0].data[0].symbolSize = 6;
        config.series[0].data[0].areaStyle = {
          color: '#334FC5',
        };
        config.series[0].data[0].lineStyle = {
          color: '#4D5EAA',
          width: 2,
        };
      }
      return config;
    },
    readyOnce(e) {
      e.resize();
    },
    async exportDetail() {
      const data = await getzbExport({
        ...this.form,
        operator_type: this.operatorType,
      });
      downloadBlobFile(data);
    },
    // pv指数上报
    async PV_report() {
      await api.pv_report({ type: 1, t: Date.parse(new Date()) });
    },
    /**
     * @description: 缺陷闲情 select 切换
     * @param {*} val
     * @return {*}
     */
    productionLineChange(val) {
      const from = JSON.parse(JSON.stringify(Object.assign(this.form, this.defectForm)));
      // this.fromData.outsourcer = 'D'
      // this.fromData.operator = 'TO_wnj001764'
      // this.fromData.production_line = 'P_0066'
      if (val === 1) {
        this.getDefectDetailsTable();
        this.getData(
          'getInsideQxTop',
          from,
          this.defectDetails
        );
        this.getData(
          'getInsideQxRate',
          from,
          this.itemdefectDetailsLine
        );
      } else {
        this.getData(
          'getInsideQxTop',
          from,
          this.defectDetails
        );
        this.getData(
          'getInsideQxRate',
          from,
          this.itemdefectDetailsLine
        );
      }
    },
    /**
     * @description: 获取缺陷详情table数据
     * @param {*}
     * @return {*}
     */
    async getDefectDetailsTable() {
      this.form.outsourcer = this.$route.query.outsourcer1;
      this.fromData = JSON.parse(JSON.stringify(Object.assign(this.form, this.defectForm)));
      // this.fromData.outsourcer = 'D'
      // this.fromData.operator = 'TO_wnj001764'
      // this.fromData.production_line = 'P_0066'
      api.getInsideQxDetailQuery({ ...this.fromData, ...this.pagination })
        .then((res) => {
          this.tableData = res.data;
          this.pagination.totalCount = res.totalCount;
          this.pagination.pageNo = res.pageNo;
          this.pagination.pageSize = res.pageSize;
        });
    },
    /**
     * @description: 获取缺陷数据详情
     * @param {*}
     * @return {*}
     */
    getDefectData() {
      this.form.outsourcer = this.$route.query.outsourcer1;
      const from = JSON.parse(JSON.stringify(Object.assign(this.form, this.defectForm)));
      // from.outsourcer = 'D'
      // from.operator = 'TO_wnj001764'
      // from.production_line = 'P_0066'
      this.getData(
        'getInsideQxTop',
        from,
        this.defectDetails
      );
      this.getData(
        'getInsideQxRate',
        from,
        this.itemdefectDetailsLine
      );
    },
    async getData(method, params, setData) {
      this.defectDetailsLoading = true;
      this.itemdefectDetailsLineLoading = true;
      const res = await api[method](params);
      if (method === 'getInsideQxTop') {
        this.defectDetailsLoading = false;
      }
      if (method === 'getInsideQxRate') {
        this.itemdefectDetailsLineLoading = false;
      }
      if (method === 'getInsideQxRate' && res.length > 0) {
        setData.columns =  Object.keys(res[0]);
        for (let i = 0; i < setData.columns.length; i++) {
          if (setData.columns[i] === 'statis_time') {
            setData.columns.splice(i, 1); // 如果数据组存在该元素，则把该元素删除
            break;
          }
        }
        setData.columns.unshift('statis_time'); // 再添加到第一个位置
        setData.width = 100 / setData.columns.length;
        res.map((item) => {
          Object.keys(item).map((item1) => {
            if (item1 !== 'statis_time') {
              item[item1] = (item[item1] / 100).toFixed(2);
            }
          });
        });
      }
      setData.rows = res;
    },
    async exportFile() {
      this.form.outsourcer = this.$route.query.outsourcer1;
      // this.form.outsourcer = 'D'
      // this.form.operator = 'TO_wnj001764'
      // this.form.production_line = 'P_0066'
      this.fromData = JSON.parse(JSON.stringify(Object.assign(this.form, this.defectForm)));
      const res = await api.getInsideQxDetailExport({ ...this.fromData, ...this.pagination });

      downloadBlobFile(res);
      if (res && res.length === 0) {
        this.$message.info('暂无数据!');
      }
    },
    currentChange(val) {
      this.pagination.pageNo = val;
      this.getDefectDetailsTable();
    },
  },
};
</script>
<style lang="less" scoped>
.personnel-portrait-details-content {
  flex: 1;
  width: 100%;
  display: flex;
  margin-top: 16px;
  padding: 0 0 0 20px;
}

.first-content {
  display: flex;
}

.comm-style {
  width: 162px;
  height: 30px;
}

.wrap-btn {
  display: flex;
}

.export-span {
  font-size: 14px;
  color: #2cb9b8;
  cursor: pointer;
  z-index: 9999;
}

.btn-style {
  display: flex;
  width: 58px;
  height: 30px;
  justify-content: center;
  align-items: center;
}

.main-content {
  flex: 1;
  overflow: auto;
  display: flex;
  flex-flow: column;

  .content-result {
    flex: 1;
    padding-right: 20px;
    overflow-y: auto;
  }
}

.tabs {
  & /deep/ #tab-zhizuo {
    width: 96px;
    text-align: center;
  }

  & /deep/ #tab-neijian {
    width: 96px;
    text-align: center;
  }
}

.el-card-style {
  margin-bottom: 10px;

  // & /deep/ .el-card__body {
  //   padding-top: 0;
  // }

  /*padding: 20px;*/
}

.first-content-left {
  display: flex;
  width: 422px;
  flex-direction: column;
}

.first-content-left-title {
  color: #071031;
  font-size: 14px;
  font-weight: 500;
  height: 40px;
  line-height: 40px;
}

.second-content-top {
  display: flex;

  span {
    display: flex;
    min-height: 72px;
    flex: 1;
    background-color: #f4f8ff;
    border-radius: 4px;
    color: #071031;
    font-size: 14px;
    margin-right: 12px;
    flex-direction: column;

    div {
      padding: 11px 10px 10px 10px;
      text-align: center;
      color: #071031;
    }

    i {
      text-align: center;
      font-weight: bold;
      font-family: PingFangSC-Medium, PingFang SC;
      font-style: normal;
      font-size: 18px;

      b {
        color: #858a9a;
        font-size: 12px;
      }
    }

    &:last-of-type {
      margin-right: 0;
    }
  }
}

.content-right {
  flex: 1;
  overflow-y: auto;
}

.second-content-bottom {
  margin-top: 19px;

  & /deep/ table {
    width: auto !important;
    border: 1px solid #e8e8e8;
    border-top: none;

    thead {
      tr th {
        background: #f6f7fb;
        font-weight: normal;
      }
    }
  }
}

.comm-title-line-style {
  color: #071031;
  font-size: 14px;
  font-weight: 500;
  line-height: 40px;
  margin-bottom: 10px;
}

.dimension-content {
  display: flex;
  flex-direction: column;
}

.dimension-content-top {
  display: flex;
  justify-content: space-between;
}

.dimension-content-top-select {
  width: 162px;
  height: 28px;
}

.targetDetail {
  display: flex;
  justify-content: space-between;
}

.detail-table-style {
  & /deep/ table tr th {
    background-color: #f6f7fb;
    font-weight: 400;
  }
}

.query-form {
  .el-form-item {
    & /deep/ .el-form-item__label {
      &::before {
        content: none;
      }
    }
  }
}
.tableInfo{
  width:100%;border:1px solid #e8e8e8;height:fit-content;max-height:550px;overflow:auto;min-height:150px;
  .tableTou{
    width:100%;display:flex;border-bottom:1px solid #e8e8e8;background:#FAFAFA;
    .tableTouInfo{
      text-align:center;min-height:39px;border-right:1px solid #e8e8e8;margin-bottom:0;
    }
  }
  .tableTd{
    width:100%;display:flex;border-bottom:1px solid #e8e8e8;
    .tableDd{
    text-align:center;height:39px;border-right:1px solid #e8e8e8;line-height:39px;margin-bottom:0
    }
  }
  .tableTd:hover{
    background:#F0F7FF
  }
}
  .trend {
    color: #071031;
    font-size: 14px;
    font-weight: 500;
    line-height: 40px;
    margin-bottom: 10px;
  }
</style>
